import { useEffect } from "react"
import { v4 as uuid } from "uuid";
import { TInnerStateCheque } from "./IInnerstate";
import ChequesList from "./list/chequesList";
import ChequeRegister from "./register/chequeRegister";
import { IFormInnerState } from "../form/IFormInnerState";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";

export default function WaitCheque({ referenceKey, setStep, setFormInnerState }: IFormInnerState) {
    const navigate = useNavigate();
    const setInnerState = (state: TInnerStateCheque) => navigate(`/loans/request/Cheque/${state === 'chequeList' ? '' : state}`);
    return (
        <div>
            <Routes>
                <Route index element={<ChequesList setInnerState={setInnerState} setStep={setStep} referenceKey={referenceKey} />} />
                <Route path="chequeRegister" element={<ChequeRegister setInnerState={setInnerState} setStep={setStep} referenceKey={referenceKey} />} />
                <Route path="*" element={<Navigate to="/loans/request/Cheque" replace />} />
            </Routes>
        </div>
    )
}
